import { render } from "./ListProperty.vue?vue&type=template&id=0446cb56&bindings={\"pageNumber\":\"data\",\"itemByPage\":\"data\",\"properties\":\"props\",\"paginatedData\":\"options\",\"updatePageNumber\":\"options\"}"
import script from "./ListProperty.vue?vue&type=script&lang=js"
export * from "./ListProperty.vue?vue&type=script&lang=js"

import "./ListProperty.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script